import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { List, Button } from 'antd';
import './ParametersList.scss';
import { LoadingCard } from 'components';

const ParametersList = ({
  loading,
  data,
  setValor,
  setIdParametro,
  setEjemplo,
  setEventValue,
  setIsVisibleConfirmInfoModal,
  setStorageSelectedSeccion,
  updateValue,
  idParametroStorage,
  setIdParametroStorage
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedValor, setSelectedValor] = useState('');

  const handleOk = (parametro) => {
    if (updateValue !== '' && selectedValor !== updateValue) {
      setStorageSelectedSeccion(parametro);
      return setIsVisibleConfirmInfoModal(true);
    }
    setSelectedItem(parametro.idParametro);
    setIdParametro(parametro.idParametro);
    setIdParametroStorage(parametro.idParametro);
    setEjemplo(parametro.ejemplo);
    setSelectedValor(parametro.valor);
    setEventValue('');
    return setValor(parametro.valor);
  };

  useEffect(() => {
    if (idParametroStorage !== null) {
      setSelectedItem((prevSelectedItem) => {
        if (prevSelectedItem !== idParametroStorage) {
          return idParametroStorage;
        }
        return prevSelectedItem;
      });
    }
  }, [idParametroStorage]);

  useEffect(() => {
    if (data && data.length > 0) {
      // eslint-disable-next-line react/prop-types
      const seccionInicial = data[0].idParametro;
      // eslint-disable-next-line react/prop-types
      const valorInicial = data[0].valor;
      // eslint-disable-next-line react/prop-types
      const ejemploInicial = data[0].ejemplo;

      setSelectedItem((prevSelectedItem) => {
        if (prevSelectedItem !== seccionInicial) {
          return seccionInicial;
        }
        return prevSelectedItem;
      });

      setIdParametro((prevIdparametro) => {
        if (prevIdparametro !== seccionInicial) {
          return seccionInicial;
        }
        return prevIdparametro;
      });

      setValor((prevValor) => {
        if (prevValor !== valorInicial) {
          return valorInicial;
        }
        return prevValor;
      });

      setEjemplo((prevEjemplo) => {
        if (prevEjemplo !== ejemploInicial) {
          return ejemploInicial;
        }
        return prevEjemplo;
      });

      setSelectedValor((prevSelectedValor) => {
        if (prevSelectedValor !== valorInicial) {
          return valorInicial;
        }
        return prevSelectedValor;
      });
    }
  }, [data]);

  return (
    <div className="container-list">
      {loading ? (
        <LoadingCard visible />
      ) : (
        <List
          size="large"
          bordered
          dataSource={data}
          renderItem={(item) => (
            <List.Item>
              <Button
                type="link"
                className={selectedItem === item.idParametro ? 'selected-list-item' : ''}
                onClick={() => handleOk(item)}>
                {item.nombre_parametro}
              </Button>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

ParametersList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  setValor: PropTypes.func.isRequired,
  setIdParametro: PropTypes.func.isRequired,
  setEjemplo: PropTypes.func.isRequired,
  setEventValue: PropTypes.func.isRequired,
  setIsVisibleConfirmInfoModal: PropTypes.func.isRequired,
  setStorageSelectedSeccion: PropTypes.func.isRequired,
  updateValue: PropTypes.string.isRequired,
  idParametroStorage: PropTypes.number.isRequired,
  setIdParametroStorage: PropTypes.func.isRequired
};

export default ParametersList;
